import {
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { Table } from '@trussworks/react-uswds';
import classNames from 'classnames';
import EmptyTableRow from '../EmptyTableRow';
import Pagination from '@components/pagination/Pagination';

const TanStackTableBasic = ({
  addButtonText,
  columns,
  data,
  isReadOnly,
  onAddClick,
  placeholderText,
  rowErrorIndices = [],
}) => {
  // Initialize TanStack table
  const table = useReactTable({
    autoResetPageIndex: false,
    columns,
    data: data,
    manualPagination: false,
    enableRowSelection: false,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 10,
      },
    },
  });
  return (
    <div className='pn-table-container'>
      <Table bordered fullWidth>
        <thead>
          <>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    style={{
                      position: 'relative',
                      userSelect: 'none',
                      width: header.getSize() + 'px',
                    }}
                  >
                    <div style={{ position: 'relative' }}>
                      {flexRender(header.column.columnDef.header, header.getContext())}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </>
        </thead>
        <tbody>
          {table.getRowModel()?.rows?.length === 0 && (
            <EmptyTableRow
              addButtonText={addButtonText}
              isReadOnly={isReadOnly}
              onAddClick={onAddClick}
              placeholderText={placeholderText}
            />
          )}
          {table.getRowModel()?.rows?.map((row, rowIndex) => {
            const rowStyles = classNames({
              'selected-row': row.getIsSelected(),
              'row-error': rowErrorIndices?.includes(rowIndex),
            });

            return (
              <tr key={row.id} className={rowStyles}>
                {row.getVisibleCells().map((cell, index) => {
                  const cellDivStyles = classNames('pn-cell display-flex', {
                    'text-center': cell?.column?.columnDef?.meta?.centerText,
                  });
                  const cellTdStyles = classNames({
                    'content-cell': index > 0,
                    'cell-error': !cell?.column?.columnDef?.meta?.optional && !cell.getValue(),
                  });
                  return (
                    <td
                      key={`${row.id}-${cell.id}`}
                      style={{ width: cell?.column?.getSize() + 'px' }}
                      className={cellTdStyles}
                    >
                      <div className={cellDivStyles}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</div>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
      <Pagination
        currentPage={table.getState().pagination.pageIndex + 1}
        itemsPerPage={table.getState().pagination.pageSize}
        onPageChange={(pageNumber) => table.setPageIndex(pageNumber - 1)}
        onPageSizeChange={(pageSize) => table.setPageSize(pageSize)}
        pageCount={table.getPageCount()}
      />
    </div>
  );
};

export default TanStackTableBasic;
